module.exports = __webpack_public_path__ + "img/loader.f84ede40.gif";